import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link'; 

export class JRETSDenGoControllerInterface extends Component {
    static displayName = JRETSDenGoControllerInterface.name;

  constructor(props) {
    super(props);
    this.state = { currentCount: 0 };
    this.incrementCounter = this.incrementCounter.bind(this);
  }

  incrementCounter() {
    this.setState({
      currentCount: this.state.currentCount + 1
    });
  }

  render() {
    return (
      <div>
        <div class="mainbody" align="center">
          <img src="images/JRETSDenGoControllerInterface.png" border="0" />
        </div>

        <p />
        <div class="mainheader" align="center">
          <a href="download/Konkyu.JRETS.DenGoControllerInterface_v2.1.zip" target="_blank">[Download] Konkyu.JRETS.DenGoControllerInterface_v2.1.zip (1,137KB)</a> <br />
                Version: 2.1 (Build 8579.40456) <br />
                Release Date: 28 Jun 2023 (<Link to="#versionHistory">Release Note</Link>)
		    </div>

        <p />

        <div class="mainheader">
          <hr />
          <h3>Content</h3>
          <ul>
            <li><Link to="#license">License</Link></li>
            <li><Link to="#introduction">1. Introduction</Link></li>
            <li><Link to="#prerequisite">2. Prerequisite</Link></li>
            <li><Link to="#installation">3. Installation</Link></li>
            <li><Link to="#configuration">4. Configuration</Link></li>
            <li><Link to="#systemSupport">5. Bugs Reporting &amp; System Support</Link></li>
            <li><Link to="#versionHistory">6. Release Note / Version History</Link></li>
          </ul>
          <hr />
          <h3 id="license">License</h3>
          <p>This application includes SlimDX library (Copyright © 2007-2011 SlimDX Group, Released with MIT license).</p>
          <p>Konkyu.JRETS.DenGoControllerInterface<br />Copyright © 2002-2022</p>
          <p>Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:</p>
          <p>The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.</p>
          <p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>
          <hr />
          <h3 id="introduction">1. Introduction</h3>
          <ul>
            <li>Konkyu.JRETS.DenGoControllerInterface (The interface plugin) is a controller interface designed for using Densha De Go! USB Controllers by Taito in "<a href="https://store.steampowered.com/app/2111630/JR_EAST_Train_Simulator/" target="_blank">JR East Train Simulator</a>".</li>
            <li>The interface plugin is compatible with the following devices for Windows:
              <ul>
                <li><a href="http://www.unbalance.co.jp/dengo/dgoc" target="_blank">DGOC-44U - 電車でGO!コントローラ（USB版)</a> (Densha De Go! Controller USB [Two-Handle])</li>
                <li><a href="http://www.unbalance.co.jp/dengo/ohc" target="_blank">DGC-255 - 電車でGO！ワンハンドルコントローラ（USB版)</a> (Densha De Go! One-Handle Controller USB)</li>
              </ul>
            </li>
          </ul>
          <hr />
          <h3 id="prerequisite">2. Prerequisite</h3>
          <ul>
            <li>You must have the following applications installed before using the interface:
              <ul>
                <li><a href="https://store.steampowered.com/app/2111630/JR_EAST_Train_Simulator/" target="_blank">JR East Train Simulator</a></li>
                <li><a href="http://www.microsoft.com/en-us/download/details.aspx?id=22" target="_blank">Microsoft .NET Framework 3.5</a></li>
                <li><a href="http://www.microsoft.com/en-us/download/details.aspx?id=35" target="_blank">DirectX End-User Runtime</a></li>
              </ul>
            </li>
          </ul>
          <hr />
          <h3 id="installation">3. Installation</h3>
          <ol>
            <li><b><u><font color="red">Important Note:</font></u></b></li>
            <ul>
              <li>Steam has enabled "Steam Input" to convert joystick input into the game by default, while the input does not match with the game's specification, and affects the joystick behaviour in game.</li>
              <li>Before proceeding, you MUST follow the steps below to disable "Steam Input" for "<a href="https://store.steampowered.com/app/2111630/JR_EAST_Train_Simulator/" target="_blank">JR East Train Simulator</a>":</li>
              <ol>
                <li>
                  In Steam Library game list, right click on "JR East Train Simulator", then click "<b><u>Properties...</u></b>".<br />
                  <img src="images/Steam_Controller_Fix_01.png" border="0" />
                </li>
                <li>
                  Navigate to "Controller" section in the poped window, then ensure the option "<b><u>Disable Steam Input</u></b>" has been selected for "<b><u>Override for JR East Train Simulator</u></b>".
                  <img src="images/Steam_Controller_Fix_02.png" border="0" />
                </li>
              </ol>
            </ul>
            <li>Unzip the package.</li>
            <li>Execute "Konkyu.JRETS.DenGoControllerInterface.exe" file.</li>
            <li>Launch "JR East Train Simulator" game.</li>
            <li><b>Players need to move the physical controller notches to Neutral / EB or flip the reverser to Forward / Backward once to re-align notches between the controller and the game when starting new game / there is discrepancy in between.</b></li>
          </ol>
          <hr />
          <h3 id="configuration">4. Configuration</h3>
          <ul>
            <li>To configure controller properties, click "Properties..." button in the application.</li>
            <li>You may configure Button Assignments in properties dialog.</li>
          </ul>
          <hr />
          <h3 id="systemSupport">5. Bugs Reporting & System Support</h3>
          <ul>
            <li>Bugs Reporting & System Support email: support@konkyu.net</li>
          </ul>
          <hr />
          <h3 id="versionHistory">6. Release Note / Version History</h3>
          <ul>
            <li>28 Jun 2023 - Version 2.1
              <ul>
                <li>Update for the latest release of "JR East Train Simulator" (1.0.1.173 / Build ID: 11575620).</li>
              </ul>
            </li>
            <li>18 Nov 2022 - Version 2.0
              <ul>
                <li>Remove dependency on game process memory access - improve compatibility across game versions.</li>
                <li>Interface will no longer automatically re-align notches between physical controller and game application via game process memory access.</li>
                <li>Players need to move the physical controller notches to Neutral / EB or flip the reverser to Forward / Backward once to re-align notches between the controller and the game when starting new game / there is discrepancy in between.</li>
              </ul>
            </li>
            <li>04 Oct 2022 - Version 1.1
              <ul>
                <li>Update for the latest release of "JR East Train Simulator" (1.0.1.34).</li>
              </ul>
            </li>
            <li>29 Sep 2022 - Version 1.0
              <ul>
                <li>Initial release.</li>
              </ul>
            </li>
          </ul>
        </div>

        <p />

      </div>
    );
  }
}
